import gql from "graphql-tag";

const queryCreate = gql`
  mutation($name: String!, $description: String) {
    createPermissionAction(data: { name: $name, description: $description }) {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!, $name: String, $description: String) {
    updatePermissionAction(
      id: $id
      data: { name: $name, description: $description }
    ) {
      id
      name

      updatedAt
      createdAt
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deletePermissionAction(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query {
    getAllPermissionAction {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getPermissionAction(id: $id) {
      id
      name
      updatedAt
      createdAt
      description
      author {
        id
        fullname
      }
    }
  }
`;

const queryGetListNamePermissionAction = gql`
  query {
    getListNamePermissionAction
  }
`;

export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
  queryGetListNamePermissionAction,
};
